module.exports = __webpack_public_path__ + "img/deepwater1.4034dbcd.png";